import { useState } from 'react';
import SelectCouponType from './SelectCouponType';
import Close from '../../../../../Assets/Modals/closeIcon.svg';
import Percent from '../../../../../Assets/Modals/Percent.svg';
import RupeeGray from '../../../../../Assets/Modals/RupeeGray.svg';
import TickMark from '../../../../../Assets/Modals/TickMark.svg';

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from "@mui/x-date-pickers";
import { CalendarIcon } from '@mui/x-date-pickers';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, setActionAlert, setActiveSection } from '../../../../../Features/dropTrackProductsSlice';
import { createNewCoupon } from '../../../../../lib/utils/apiCalls';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatDate } from '../../../../../lib/utils/utils';
import { showToast } from '../../../../../Components/Toaster/Toaster';

function CreateNewCoupon() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const activeProduct = useSelector((state) => state.dropTrackProducts.activeProduct);

    const defaultFormErrors = {
        couponName: '',
        discountPercent: '',
        discountPrice: '',
        date: '',
    };

    const [couponType, setCouponType] = useState('');
    const [formErrors, setFormErrors] = useState(defaultFormErrors);

    const dates = {
        from: null,
        to: null,
    }

    const [date, setDate] = useState(dates);
    const [couponName, setCouponName] = useState('');
    const [discountPrice, setDiscountPrice] = useState('');
    const [discountPercent, setDiscountPercent] = useState('');
    const [confirmation, setConfirmation] = useState(false);

    const handleNameChange = (e) => {
        setCouponName(e.target.value.toUpperCase());
    }

    const handlePricechange = (e) => {
        setDiscountPrice(e.target.value);
    }

    const handlePercentChange = (e) => {
        const percent = e.target.value;

        if(percent < 100) {
            setDiscountPercent(percent);
        }
    }

    const handleButtonClick = () => {
        dispatch(closeModal());
    };

    const handleCouponSelection = (type) => {
        setCouponType(type);
    }

    const handleNotifyButton = async () => {
        const validationErrors = {};

        const fromDate = new Date(date.from);
        const toDate = new Date(date.to);

        const fromTimestamp = fromDate.getTime();
        const toTimestamp = toDate.getTime();

        if(!couponName.trim()) {
            validationErrors.couponName = 'Coupon Name is required';
        }

        if(couponType === 'PERCENTAGE_DISCOUNTS') {
            if(!discountPercent.trim()) {
                validationErrors.discountPercent = 'Discount Percentage is required';
            }
        }
        else {
            if(!discountPrice.trim()) {
                validationErrors.discountPrice = 'Discount Price is required';
            }
        }

        if(fromTimestamp || toTimestamp) {
            if(!fromTimestamp) {
                validationErrors.date = 'Select Start Date';
            }
            else if(!toTimestamp) {
                validationErrors.date = 'Select End Date';
            }
            else if(fromDate > toDate) {
                validationErrors.date = 'Start date should be earlier than End date';
            }
        }
        else {
            validationErrors.date = 'Select date range';
        }

        if(Object.keys(validationErrors).length === 0) {
            const callData = {
                productId: activeProduct.productId,
                couponName,
                couponType,
                discountPercentage: discountPercent ? discountPercent : 0,
                discountAmount: discountPrice ? discountPrice : 0,
                startDate: fromDate.toISOString(),
                endDate: toDate.toISOString(),
                isOnlyForDropTrackUsers: confirmation,
            };

            try {
                const response = await createNewCoupon(callData);
                // eslint-disable-next-line eqeqeq
                if (response.statusCode == 10000) {
                    showToast('New coupon created succcessfully!', 'success');
                    dispatch(closeModal());
                    navigate(`${location.pathname}/${activeProduct.productId}`);
                    dispatch(setActionAlert({
                        type: 'New Coupon',
                        startDate: formatDate(fromDate),
                        endDate: formatDate(toDate),
                    }));
                    dispatch(setActiveSection('insights'));
                }
            }
            catch(err) {
                if(err.response.status === 500) {
                    showToast(err.response.data, 'warning');
                }
                else {
                    showToast(`Error occurred`, 'error');
                }
            }
        }
        else {
            setFormErrors(validationErrors);
            return;
        }
    }

    return (
        <div className="w-1/2 h-fit bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-5">
            {
                couponType === '' ? 
                <SelectCouponType 
                    selectCouponType={val => handleCouponSelection(val)} 
                /> : 
                <>
                    <div className="flex items-center justify-between">
                        <h1 className='font-urbanist-regular font-semibold text-2xl text-[#121212]'>Create New Coupon</h1>

                        <button onClick={handleButtonClick}>
                            <img src={Close} alt="Close Modal" />
                        </button>
                    </div>

                    <div className="flex flex-col gap-10">
                        <form action="" className="flex flex-col gap-4">
                            <div className="flex flex-col gap-2">
                                <div className="flex items-center justify-between">
                                    <label className='m-0 font-urbanist-regular font-medium text-base text-[#000000]' htmlFor="name-input">
                                        New Coupon Name<span className='text-[#FF0000]'>*</span>
                                    </label>

                                    {formErrors.couponName && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.couponName}</p>}
                                </div>
                                

                                <div className="h-14 bg-[#F5F5F5] px-2 py-[6px] rounded-lg border border-[#EAEAEA] flex items-center justify-center focus-within:border-primaryColor">
                                    <input 
                                        value={couponName} 
                                        onChange={handleNameChange} 
                                        placeholder='Enter coupon name' 
                                        className='w-full bg-transparent outline-none border-none text-sm font-medium placeholder:text-[#666666]' 
                                        type="text" 
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col gap-2">
                                <div className="flex items-center justify-between">
                                    <label className='m-0 font-urbanist-regular font-medium text-base text-[#000000]' htmlFor="name-input">
                                        {couponType === 'PERCENTAGE_DISCOUNTS' ? 'Percentage Discount' : 'Fixed Discount'}
                                        <span className='text-[#FF0000]'>*</span>
                                    </label>

                                    {formErrors.discountPercent && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.discountPercent}</p>}

                                    {formErrors.discountPrice && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.discountPrice}</p>}
                                </div>

                                {couponType === 'PERCENTAGE_DISCOUNTS' ? 
                                    <div className="h-14 bg-[#F5F5F5] focus-within:border-primaryColor px-2 py-[6px] rounded-lg border border-[#EAEAEA] flex items-center justify-between">
                                        <input 
                                            value={discountPercent} 
                                            onChange={handlePercentChange} 
                                            placeholder='0' 
                                            className='w-fit flex-grow bg-transparent outline-none border-none text-sm font-medium placeholder:text-[#666666]' 
                                            type="number" 
                                        />

                                        <div className="size-6 flex items-center justify-center">
                                            <img src={Percent} alt="Percentage" />
                                        </div>
                                    </div> : 
                                    <div className="h-14 bg-[#F5F5F5] focus-within:border-primaryColor px-2 py-[6px] rounded-lg border border-[#EAEAEA] flex items-center gap-1">
                                        <div className="size-6 flex items-center justify-center">
                                            <img src={RupeeGray} alt="Rupee" />
                                        </div>

                                        <input 
                                            value={discountPrice} 
                                            onChange={handlePricechange} 
                                            className='bg-transparent flex-grow outline-none border-none text-sm font-medium placeholder:text-[#666666]' 
                                            placeholder='0.00' 
                                            type="number" 
                                        />
                                    </div>
                                }
                            </div>

                            <div className="flex flex-col gap-[14px]">
                                <div className="flex flex-col gap-2 font-urbanist-regular">
                                    <div className="flex items-center justify-between">
                                        <h1 className='font-medium text-[16px] leading-8 text-[#121212]'>
                                            Set Duration 
                                            {/* &#40;optional&#41; */}
                                        </h1>

                                        {formErrors.date && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.date}</p>}
                                    </div>
                                
                                    <p className='font-medium text-[16px] leading-[28px] text-[#666666]'>
                                        Specify your deal's duration and let the system automatically expire to coupon after promotional period.
                                    </p>
                                </div>

                                <div className="flex gap-8 text-black font-urbanist-regular">
                                    <div className="flex flex-col gap-1">
                                        <h1 className='font-normal text-base'>From</h1>

                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker']}>
                                                <DatePicker
                                                    label="Start Date" 
                                                    onChange={e => setDate({ ...date, from: e.$d })} 
                                                    slots={{ openPickerIcon: CalendarIcon }} 
                                                    sx={{
                                                        width: '180px'
                                                    }}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </div>

                                    <div className="flex flex-col gap-1">
                                        <h1 className='font-normal text-base'>To</h1>

                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker']}>
                                                <DatePicker
                                                    label="End Date" 
                                                    onChange={e => setDate({ ...date, to: e.$d })} 
                                                    slots={{ openPickerIcon: CalendarIcon, }} 
                                                    sx={{
                                                        width: '180px',
                                                    }}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-center gap-2">
                                <button 
                                    onClick={(e) => { e.preventDefault(); setConfirmation(!confirmation)}} 
                                    className={`flex items-center justify-center size-6 rounded-[6px] border border-[#D1D5DB] ${confirmation && 'bg-primaryColor border-none'}`}
                                >
                                    {confirmation && <img src={TickMark} alt="" />}
                                </button>

                                <p className='m-0 font-urbanist-regular font-normal text-[14px] leading-6'>
                                    Check this box if you want this coupon to be exclusively for Droptrack Watchers.
                                </p>
                            </div>
                        </form>

                        <button onClick={handleNotifyButton} className='bg-primaryColor hover:bg-primaryAccent px-4 py-2 rounded font-semibold text-base text-center text-buttonText' type='button'>
                            Notify DropTrack Watchers
                        </button>
                    </div>
                </>
            }
        </div>
    );
}

export default CreateNewCoupon;
